<template>
    <router-view :key="$i18n.locale + ':' + $route.fullPath" v-cloak/>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { initializeFirebase, getFcmMessage } from './util/pushNotification'
import {settingService} from './router'

export default {
  name: 'App',
  computed: {
    ...mapState({
      alert: state => state.alert
    }),
    ...mapGetters('clubs', {
      selectedClub: 'getSelectedClub'
    })
  },
  methods: {
    ...mapActions({}),
    vh: function () {
      let vh = window.innerHeight * 0.01
      document.querySelector(':root').setAttribute('style', '--vh:' + vh + 'px;')
    }
  },
  watch: {
    $route (to, from) {
      // clear alert on location change
    },
    '$store.state.users.user': function () {
      if (this.FCMToken === null || !this.$store.state.users.user) return
      settingService.setFcm(this.FCMToken).then(response => {
      }).catch(e => {
        console.log('saveFCMToken Error ==>', e)
      })
    }
  },
  data () {
    return {
      mobileFlag: false,
      FCMToken: null
    }
  },
  created () {
    initializeFirebase()
    const messaging = getFcmMessage()

    messaging.requestPermission().then(() => {
      messaging.getToken().then((token) => {
        this.FCMToken = token
        const users = this.$store.state.users
        if (!users.user || !users.userInfo) return
        settingService.setFcm(this.FCMToken).then(response => {
          console.log(response)
        })
      })
      messaging.onMessage((payload) => {
        console.log(`[${payload.data.title}]`, payload.data.msg)
        // 1 - Get current club name.
        if (!this.selectedClub) return
        // 2 - Check validation with got a current club name.
        const {club_name: clubName} = this.selectedClub
        const {data: {msg}} = payload
        if (!clubName || !msg) return
        // 3 - If true ? send notification : nothing
        const isValid = String(msg).includes(clubName)
        if (!isValid) return
        // eslint-disable-next-line no-new
        new Notification(payload.data.title, {
          body: payload.data.msg
        })
      })
    }).catch((err) => {
      console.log('Unable to get permission to notify.', err)
    })
  },
  mounted () {
    this.vh()
    window.addEventListener('resize', this.vh)
    window.addEventListener('resize', () => {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          window.scrollTo(0, 0)
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          window.scrollTo(0, 0)
        }
      }
    })
  }
}
</script>

<style>
  [v-clock] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue